module.exports = __webpack_public_path__ + "static/img/25.03818fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/ProcessAutomation/25.png
// module id = Uhoh
// module chunks = 1